import { FirstPartyAppId } from 'owa-m365-acquisitions/lib/data/M365AppId';
import { isSearchPlusChatFeatureEnabled } from './isSearchPlusChatFeatureEnabled';

/**
 * Helper function to determine if the current module and app combination
 * supports the sparkle search icon for Search Plus Chat feature.
 * @param currentModule - The current module name
 * @param selectedApp - The currently selected app ID
 * @returns true if sparkle icon is supported for this module/app combination
 */
export function isSparkleIconSupportedForModule(
    currentModule: string | undefined,
    selectedApp: string | undefined
): boolean {
    if (!currentModule || !selectedApp) {
        return false;
    }

    switch (currentModule) {
        case 'Mail':
            return isSearchPlusChatFeatureEnabled() && selectedApp === FirstPartyAppId.Mail;
        default:
            return false;
    }
}
